import ThemeToggle from './ThemeToggle/ThemeToggle';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';

import { useSearchStore } from '../../stores/searchStore';
import classNames from 'classnames';
import styles from './SwitcherBlock.module.less';

import { useMenuStateStore } from '../../stores/menuStore';
import { useThemeStore } from '../../stores/themeStore';

import FormBtn from './FormBtn/FormBtn';

export const SwitcherBlock = () => {
  const { isSearchVisible } = useSearchStore();

  const { isMenuOpen } = useMenuStateStore();
  const { theme } = useThemeStore();

  const isDisabled = isSearchVisible || isMenuOpen;

  return (
    <div
      className={classNames(styles.switcherBlock, {
        [styles.disabled]: isDisabled,
      })}
      aria-disabled={isDisabled}
    >
      <FormBtn theme={theme} />
      <LanguageSwitcher theme={theme} />
      <ThemeToggle themes={theme} />
    </div>
  );
};
